import { ErrorDescription } from './Constants';
export function resolveType(data, propertyString, resolveCallback) {
    if (data && propertyString in data) {
        if (resolveCallback) {
            resolveCallback();
        }
        return Promise.resolve(data);
    }
    throw new Error(ErrorDescription.PropertyNotFound.replace('XX', propertyString));
}
export function resolveArray(data, propertyString, allowEmpty) {
    if (allowEmpty === void 0) { allowEmpty = false; }
    if ((data && data.length > 0 && propertyString in data[0]) || allowEmpty) {
        return Promise.resolve(data);
    }
    throw new Error(ErrorDescription.PropertyNotFound.replace('XX', propertyString));
}
export function resolveDictionary(data, dataTypeName) {
    if (data && Object.keys(data).length > 0) {
        return Promise.resolve(data);
    }
    throw new Error(ErrorDescription.PropertyNotFound.replace('XX', dataTypeName));
}
//# sourceMappingURL=Utils.js.map